import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ShieldAlert, ShieldCheck, ChevronDown, ChevronUp } from "lucide-react";

const NIVEL = { critico: "bg-red-50 border-red-200 text-red-800", alerta: "bg-amber-50 border-amber-200 text-amber-900", info: "bg-slate-50 border-slate-200 text-slate-700" };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "-");

export const SecurityAlerts = () => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/empresas/seguranca?horas=24").then((r) => setD(r.data)).catch(() => setD({ alertas: [] })); }, []);
  if (!d) return null;
  const relevantes = d.alertas.filter((a) => a.nivel !== "info");
  if (relevantes.length === 0) {
    return <div className="rounded-xl border bg-emerald-50 border-emerald-200 text-emerald-800 px-4 py-2.5 text-sm flex items-center gap-2" data-testid="security-ok"><ShieldCheck className="w-4 h-4" /> Segurança: nenhum login bloqueado ou tentativa suspeita nas últimas 24h.</div>;
  }
  const top = relevantes[0];
  return (
    <div className={`rounded-xl border px-4 py-3 text-sm ${NIVEL[top.nivel]}`} data-testid="security-alert">
      <button type="button" onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between gap-2 text-left" data-testid="security-alert-toggle">
        <span className="flex items-center gap-2 font-semibold min-w-0"><ShieldAlert className="w-4 h-4 shrink-0" />
          <span className="truncate">Alerta de segurança: {d.total_falhas} falha(s) de login, {d.total_bloqueios} bloqueio(s) em {relevantes.length} conta(s)/empresa(s) nas últimas 24h{d.bloqueados_agora ? ` • ${d.bloqueados_agora} bloqueada(s) agora` : ""}</span></span>
        {open ? <ChevronUp className="w-4 h-4 shrink-0" /> : <ChevronDown className="w-4 h-4 shrink-0" />}
      </button>
      {open && (
        <ul className="mt-3 space-y-2" data-testid="security-alert-list">
          {relevantes.map((a) => (
            <li key={a.empresa_id} className="rounded-lg bg-white/70 border px-3 py-2 flex flex-wrap items-center justify-between gap-2" data-testid={`security-emp-${a.empresa_id}`}>
              <div className="min-w-0"><div className="font-semibold truncate">{a.empresa_nome}</div>
                <div className="text-xs opacity-80 truncate">{a.emails.join(", ")} • IPs: {a.ips_distintos} • último: {fmt(a.ultimo)}</div></div>
              <div className="text-xs font-bold whitespace-nowrap">{a.falhas} falha(s) • {a.bloqueios} bloqueio(s) <span className={`ml-1 px-1.5 py-0.5 rounded ${a.nivel === "critico" ? "bg-red-600 text-white" : "bg-amber-500 text-white"}`}>{a.nivel === "critico" ? "CRÍTICO" : "ALERTA"}</span></div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
